module.exports = __webpack_public_path__ + "img/guillermo-colombo.894206a8.jpg";